import { render, staticRenderFns } from "./clapCasuallyDetail.vue?vue&type=template&id=2084abbc&scoped=true"
import script from "./clapCasuallyDetail.vue?vue&type=script&lang=js"
export * from "./clapCasuallyDetail.vue?vue&type=script&lang=js"
import style0 from "./clapCasuallyDetail.vue?vue&type=style&index=0&id=2084abbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084abbc",
  null
  
)

export default component.exports